'use client'

// import { useAuth } from '@/core/store/auth'
import { Button } from '@/core/ui/atoms/button'
import { FormDateInput } from '@/core/ui/forms/date-input'
import { FormInput } from '@/core/ui/forms/input'
import { UserDetailsModel } from '@/features/auth/types/models/user-details.model'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { useRef, useState } from 'react'
import { FormProvider } from 'react-hook-form'
import { useUpdateProfile } from './use-update-profile'

type Props = {
  onSuccess: () => void
  user: UserDetailsModel | null
}

export function UpdateProfile(props: Props) {
  const t = useTranslations()

  const { form, handleSubmit, isPending } = useUpdateProfile({
    onSuccess: props.onSuccess,
    user: props.user,
  })
  const fileInputRef = useRef<HTMLInputElement>(null)
  const image = props.user?.image
  const [preview, setPreview] = useState<string | null>(null)

  // const { deleteImage, isDeleting } = useDeleteProfileImage({
  //   onSuccess: () => {
  //     setPreview(null)
  //     form.setValue('image', null)
  //     props.onSuccess()
  //   },
  // })
  return (
    <FormProvider {...form}>
      <form className='flex flex-col gap-4 p-4' onSubmit={handleSubmit}>
        <p className='text-start text-lg font-medium'>
          {t('profile.updateProfile')}
        </p>
        <div className='flex items-center gap-5 md:flex-row'>
          <div
            style={{ height: '60px', width: '60px' }}
            className='rounded-full'
          >
            <Image
              alt=''
              width={60}
              height={60}
              src={preview || image || '/images/avatar.png'}
              className='h-full w-full rounded-full border object-cover'
            />
          </div>

          <div>
            <p className='text-mountain-bluebird mb-1 text-base font-medium'>
              {t('profile.UploadProfileImage')}
            </p>
            <div className='flex gap-3'>
              <input
                ref={fileInputRef}
                type='file'
                accept='image/*'
                hidden
                onChange={e => {
                  const file = e.target.files?.[0]
                  if (file) {
                    form.setValue('image', file, { shouldValidate: true })

                    const previewUrl = URL.createObjectURL(file)
                    setPreview(previewUrl)
                  }
                }}
              />

              <Button
                color='cyan-blue'
                type='button'
                className='mt-1 h-7 cursor-pointer'
                onClick={() => fileInputRef.current?.click()}
              >
                Upload
              </Button>
              {/* <Button
                color='medium-gray'
                type='button'
                className='mt-1 h-7 cursor-pointer'
                onClick={() => deleteImage()}
                loading={isDeleting}
                disabled={!image && !preview}
              >
                Delete
              </Button> */}
            </div>
          </div>
        </div>
        <FormInput
          name='username'
          label={t('forms.nameLabel')}
          placeholder={t('forms.namePH')}
          control={form.control}
          labelClassName='text-mountain-bluebird'
          className='rounded-sm'
        />
        <FormInput
          name='email'
          label={t('forms.emailLabel')}
          placeholder={t('forms.emailPH')}
          control={form.control}
        />
        <FormDateInput
          name='birthdate'
          label={t('forms.birthdateLabel')}
          placeholder={t('forms.birthdatePH')}
          control={form.control}
        />
        <Button
          type='submit'
          loading={isPending}
          className='mt-1 h-12 w-full cursor-pointer'
        >
          {t('actions.saveChanges')}
        </Button>
      </form>
    </FormProvider>
  )
}
